export const countdownRenderer = (styles) => ({ days, hours, minutes, seconds, completed }) => {
    return (
      <section className={styles?.countdownWrapper}>
        <div>Do konca zostáva:</div>
        {completed ? (
          <div className={styles?.countdown}>finished</div>
        ) : (
          <div className={styles?.countdown}>
            {days}
            <span>d</span>:{hours}
            <span>h</span>:{minutes}
            <span>m</span>:{seconds}
            <span>s</span>
          </div>
        )}
      </section>
    );
  };